// In-house MVT student leaderboard (app/views/v2/leaderboards/*).
//
// Sorting, searching and pagination are server-side and URL-driven; the only
// client-side behavior is a progressive enhancement that auto-submits the
// "rows per page" and "group by category" selectors on change, so neither needs
// an extra "apply" button. The surrounding GET forms still work without JS.
$(document).on('turbolinks:load', function() {
  $('#leaderboard-per-page, #leaderboard-category').on('change', function() {
    if (this.form) this.form.submit();
  });
});
